const STORAGE_KEY = 'hom_pet';
const PETS = ['dog', 'cat'];

/**
 * Dogs | Cats segmented control. The initial value is set on `<html data-pet>` by an
 * inline script in `layout/theme.liquid`; this element keeps it in sync on click.
 */
class HomPetToggle extends HTMLElement {
  #controller = new AbortController();

  connectedCallback() {
    this.#controller = new AbortController();
    const { signal } = this.#controller;

    this.addEventListener('click', this.#handleClick, { signal });
    document.addEventListener('hom:pet-change', this.#sync, { signal });
    this.#sync();
  }

  disconnectedCallback() {
    this.#controller.abort();
  }

  /** @param {MouseEvent} event */
  #handleClick = (event) => {
    if (!(event.target instanceof Element)) return;

    const option = event.target.closest('[data-pet]');
    if (!(option instanceof HTMLElement)) return;

    const pet = option.dataset.pet;
    if (!pet || !PETS.includes(pet)) return;

    document.documentElement.dataset.pet = pet;
    try {
      localStorage.setItem(STORAGE_KEY, pet);
    } catch {
      // Storage can be unavailable (private mode); the choice still applies to this page.
    }
    document.dispatchEvent(new CustomEvent('hom:pet-change', { detail: { pet } }));
  };

  #sync = () => {
    const current = document.documentElement.dataset.pet;
    for (const option of this.querySelectorAll('[data-pet]')) {
      if (!(option instanceof HTMLElement)) continue;
      option.setAttribute('aria-pressed', String(option.dataset.pet === current));
    }
  };
}

if (!customElements.get('hom-pet-toggle')) {
  customElements.define('hom-pet-toggle', HomPetToggle);
}
